module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "footer-links no-print"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 text-center"
  }, [_c('div', {
    staticClass: "copyright"
  }, [_vm._v("© OpenCabana, " + _vm._s(_vm.date) + ".")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-quote no-print"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-8 offset-lg-2 text-center"
  }, [_c('p', [_vm._v("OpenCabana partners with the world's top resorts to offer and provide VIP beach and poolside cabana services.")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('ul', {
    staticClass: "footer-links"
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#/pages/contact"
    }
  }, [_vm._v("Contact")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#/hotel-partners"
    }
  }, [_vm._v("Hotel Partners")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#/pages/terms"
    }
  }, [_vm._v("Terms")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#/pages/privacy"
    }
  }, [_vm._v("Privacy")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 text-right"
  }, [_c('ul', {
    staticClass: "social-icons"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/opencabana/",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook-official",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.instagram.com/opencabana/",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-instagram",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.twitter.com/opencabana/",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-737817d5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/components/AppFooter.vue
// module id = 603
// module chunks = 2